import { render, staticRenderFns } from "./MarketingBanner.vue?vue&type=template&id=30e699a4&"
import script from "./MarketingBanner.vue?vue&type=script&lang=js&"
export * from "./MarketingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports